var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSpotify = function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#1ED760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.495 5A7.499 7.499 0 005 12.495a7.493 7.493 0 007.495 7.496 7.493 7.493 0 007.496-7.495C20 8.357 16.641 5 12.496 5zm3.44 10.818a.465.465 0 01-.645.152c-1.765-1.075-3.977-1.316-6.591-.725a.463.463 0 11-.206-.905c2.856-.653 5.31-.376 7.28.833.233.134.305.421.161.645zm.922-2.042a.593.593 0 01-.806.197c-2.015-1.245-5.087-1.603-7.469-.878a.58.58 0 11-.331-1.11c2.722-.824 6.107-.43 8.427.994.26.161.349.52.179.797zm.08-2.131c-2.418-1.433-6.403-1.567-8.713-.869a.706.706 0 01-.878-.466.706.706 0 01.466-.877c2.65-.806 7.057-.645 9.833 1.003a.7.7 0 01.242.958.682.682 0 01-.95.25z",
    fill: "#fff"
  })));
};
export default SvgSpotify;